import React, { Fragment, useState } from 'react';
import StockReportFormView from '../../../components/inventory/reports/stock_rpt/StockReportFormView';
import { Grid } from '@mui/material';
import StockReportListView from '../../../components/inventory/reports/stock_rpt/StockReportListView';
import { StockReportList } from '../../../helpers/models/Models';

const InventoryStockReportListView = () => {
    const [stockReport, setOnStockList] = useState<StockReportList[] | null>(null);
    return (
        <Fragment>
            <Grid container spacing={3}>
                <Grid item xl={4} md={4} sm={12} xs={12} lg={4}>
                    <StockReportFormView setOnStockList={setOnStockList} />
                </Grid>
                <Grid item xl={8} md={8} sm={12} xs={12} lg={8}>
                <StockReportListView stockReport={stockReport} />
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default InventoryStockReportListView